import { useEffect, useState } from 'react';
import { Checkbox, ComboBox } from '@airbus/components-react';
import SetColumnConfig, { getIcon } from '../../../shared/components/grid/SetColumnConfig';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import style from '../../../shared/components/grid/RenderEditField.module.css';
import Columnstyle from '../../../shared/components/grid/SetColumnConfig.module.css';
import { focusField } from '../../../shared/components/grid/RenderEditField';

export default function ScreenTableColumnConfig(props) {
  const { gridColumns: columnsConfig } = SetColumnConfig(props);
  const gridColumns = columnsConfig.reduce((resp, item) => {
    if (item.attrInternalName === 'form_order_no') {
      item.renderEditCell = (params) => (
        <RenderFormDropDown {...{ ...params, ...props, ...props.customProps }} />
      );
      item.renderCell = (params) => (
        <RenderCellDropDown {...{ ...params, ...props, ...props.customProps }} />
      );
    }
    if (item.attrInternalName === 'attr_mandatory') {
      item.align = 'center';

      item.renderCell = (params) => (
        <CheckBoxField {...{ ...params, ...props, ...props.customProps }} />
      );
      item.renderEditCell = (params) => (
        <RenderEditField {...{ ...params, ...props, ...props.customProps }} />
      );
    }
    if (item.attrInternalName === 'attr_available_in_grid') {
      item.align = 'center';

      item.renderCell = (params) => (
        <CheckBoxField {...{ ...params, ...props, ...props.customProps }} />
      );
      item.renderEditCell = (params) => (
        <RenderEditField {...{ ...params, ...props, ...props.customProps }} />
      );
    }
    if (item.attrInternalName === 'attr_managed_by_admin') {
      item.align = 'center';
      // item.renderCell = (params) => (
      //   <CheckBoxField {...{ ...params, ...props, ...props.customProps }} />
      // );
      item.renderEditCell = (params) => (
        <RenderEditField {...{ ...params, ...props, ...props.customProps }} />
      );
    }
    if (item.attrInternalName === 'attr_duplicate_config') {
      item.align = 'center';
      item.renderCell = (params) => (
        <CheckBoxField
          {...{ ...params, ...props, ...{ label: 'Copy Existing' }, ...props.customProps }}
        />
      );
      item.renderEditCell = (params) => (
        <RenderEditField
          {...{ ...params, ...props, ...{ label: 'Copy Existing' }, ...props.customProps }}
        />
      );
    }

    resp.push(item);
    return resp;
  }, []);
  return { gridColumns };
}
function RenderCellDropDown(params) {
  return (
    <div className={Columnstyle.cell}>
      <div className={Columnstyle.cell_content}>{params.formattedValue}</div>{' '}
      {getIcon('singleSelect')}
    </div>
  );
}
function RenderFormDropDown(params) {
  const { allDropdowns, id, field, setCustomRows } = params;
  let { value } = params;
  const [prevVal] = useState(value);
  const apiRef = useGridApiContext();
  const valueOptions = allDropdowns.form_order_no;
  const customOptions = allDropdowns.form_order_no;

  useEffect(() => {
    focusField({ id, field });
  }, []);

  const onValueChangeHandler = async (val, id) => {
    if (val) {
      value = val;
      await apiRef.current.setEditCellValue({ id, field, value: val });
      apiRef.current.stopCellEditMode({ id, field });
      setCustomRows((allrows) => {       
        const newState = [...allrows];
        const changeIndex = newState.findIndex((item) => item.form_order_no == val);
        const swappedIndex = newState.findIndex((item) => item.form_order_no == prevVal);
        newState[changeIndex].form_order_no = prevVal;
        newState[swappedIndex].form_order_no = val;

        newState[changeIndex].status = 'E';
        newState[swappedIndex].status = 'E';
        return newState;
      });
    }
  };

  return (
    <div className={style.render_edit_cell}>
      <ComboBox
        id={id + '_' + field}
        className='h-100'
        hideClear={true}
        autoFocus={true}
        options={customOptions}
        value={valueOptions?.find((item) => item.value == value)}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        onChange={(obj) => onValueChangeHandler(obj == '' ? obj : obj.value, id)}
      ></ComboBox>
    </div>
  );
}
const CheckBoxField = (params) => {
  const { value } = params;
  const checked = value === true || value === 'copy-existing';
  return <Checkbox checked={checked} readOnly label={params.label} />;
};

function RenderEditField(params) {
  const { api, id, field, value: initialValue } = params;
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(initialValue === 'copy-existing' || initialValue);
  }, [initialValue]);

  const handleChange = (e) => {
    const newChecked = e.target.checked;
    setChecked(newChecked);
    let checkVal;
    if (field === 'attr_duplicate_config') {
      checkVal = newChecked ? 'copy-existing' : '';
    } else {
      checkVal = e.target.checked;
    }

    api.setEditCellValue({ id, field, value: checkVal });
  };

  const blurHandler = () => {
    api.stopCellEditMode({ id, field, ignoreModifications: false });
  };

  return (
    <Checkbox checked={checked} onChange={handleChange} onBlur={blurHandler} label={params.label} />
  );
}
